import React from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
// import logo from "../assets/logo-no-background.png";
import logo2 from "../assets/v3.png";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { Typography } from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import SwipeableRightDrawer from "./SwipeableRightDrawer";
import ProfileMenuButton from "./ProfileMenuButton";
import InstrumentsMenuButton from "./InstrumentsMenuButton";
import SearchStock from "./SearchStock";

function Header(props, ref) {
	const navigate = useNavigate(); // Hook for programmatic navigation

	const goToHome = () => {
		navigate("/");
	};

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar
				ref={ref}
				position="fixed"
				elevation={0}
				color="#3A2206"
				sx={{
					borderBottom: "1px solid rgba(58, 34, 6, 0.1)",
					bgcolor: "rgba(255, 255, 255, 0.75)", // Semi-transparent background
					backdropFilter: "blur(5px)", // Adds the blur effect
					WebkitBackdropFilter: "blur(5px)", // Safari support
				}}
			>
				<Toolbar>
					<IconButton
						size="large"
						edge="start"
						color="inherit"
						aria-label="home"
						onClick={goToHome}
						disableTouchRipple
						sx={{
							height: "60px", // Set your desired height here
							alignItems: "center",
							mr: 2,
							p: 1.1,
							// border: "1px solid gray",
							"&:hover": {
								bgcolor: "transparent",
							},
						}}
					>
						<img
							src={logo2}
							alt="logo"
							style={{ width: 40, height: 40 }}
						/>
					</IconButton>
					<SearchStock />
					<Box sx={{ flexGrow: 1 }} />
					<Box sx={{ display: { xs: "none", md: "flex" } }}>
						<InstrumentsMenuButton></InstrumentsMenuButton>
						<Button
							// variant="text"
							disableTouchRipple
							color="inherit"
							size="large"
							startIcon={<TelegramIcon sx={{}} />}
							sx={{
								textTransform: "none",
								marginRight: "1rem",
								height: 45,
								mt: "auto",
								mb: "auto",
								borderRadius: 2.5,
								color: "rgb(100, 100, 100)",
								"&:hover": {
									color: "black",
								},
								position: "relative",
							}}
						>
							{/* Community Chat */}
							<Typography fontWeight={"bold"} variant="body1">
								Chat
							</Typography>
						</Button>
						<Button
							// variant="text"
							disableTouchRipple
							color="inherit"
							size="large"
							sx={{
								textTransform: "none",
								marginRight: "1rem",
								height: 45,
								mt: "auto",
								mb: "auto",
								borderRadius: 2.5,
								color: "rgb(100, 100, 100)",
								"&:hover": {
									color: "black",
								},
								position: "relative",
							}}
						>
							<Typography
								// fontWeight={'bold'}
								variant="body1"
								// color="#3a2206"
							>
								Shop
							</Typography>
						</Button>
						<ProfileMenuButton></ProfileMenuButton>
					</Box>
					<Box sx={{ display: { xs: "flex", md: "none" } }}>
						<SwipeableRightDrawer></SwipeableRightDrawer>
					</Box>
				</Toolbar>
			</AppBar>
		</Box>
	);
}
export default React.forwardRef(Header);
